import * as fromDatatype from "../datatype-library/index";

export interface bl_del_slot_gen_doc_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    delivery_slot_hdr_guid: fromDatatype.GuidDataFieldInterface;
    position_id: fromDatatype.IntegerDatatypeInterface;
    duration: fromDatatype.NumericDatatypeInterface;
    start_date_time: fromDatatype.TimestampTzDatatypeInterface;
    end_date_time: fromDatatype.TimestampTzDatatypeInterface;
    gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gen_doc_hdr_server_doc_1: fromDatatype.VarcharDatatypeInterface;
    sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    sales_entity_hdr_name: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_del_slot_gen_doc_link_RowClass implements bl_del_slot_gen_doc_link_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    delivery_slot_hdr_guid: fromDatatype.GuidDataFieldInterface;
    position_id: fromDatatype.IntegerDatatypeInterface;
    duration: fromDatatype.NumericDatatypeInterface;
    start_date_time: fromDatatype.TimestampTzDatatypeInterface;
    end_date_time: fromDatatype.TimestampTzDatatypeInterface;
    gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gen_doc_hdr_server_doc_1: fromDatatype.VarcharDatatypeInterface;
    sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    sales_entity_hdr_name: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}